import { useState } from 'react'
import { KTCard, KTCardBody } from '../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { CustomTabs, TabItem } from '../../../../components'
import { IndicadoresHeader } from './components/header/IndicadoresHeader'
import { SecaoOperacional } from './components/secoes/SecaoOperacional'
import { SecaoPerformance } from './components/secoes/SecaoPerformance'
import { SecaoQualidade } from './components/secoes/SecaoQualidade'
import { FamiliaIndicadores } from './core/_models'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponsePerformanceProvider } from './core/QueryResponsePerformanceProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { QueryResponseQualidadeProvider } from './core/QueryResponseQualidadeProvider'

type Props = {
  abaAtiva: FamiliaIndicadores
  onAbaChange: (aba: FamiliaIndicadores) => void
}

/**
 * Moldura única das famílias de indicadores: uma rota, uma permissão, um
 * filtro e uma exportação. Trocar de aba troca a seção e o response provider
 * dela; o filtro fica acima e não remonta.
 */
const IndicadoresMoldura = ({ abaAtiva, onAbaChange }: Props) => {
  const { t } = useT()

  const abas: TabItem<FamiliaIndicadores>[] = [
    { id: 'operacional', label: t('indicadores.aba.operacional') },
    { id: 'qualidade', label: t('indicadores.aba.qualidade') },
    { id: 'performance', label: t('indicadores.aba.performance') },
  ]

  return (
    <KTCard>
      <KTCardBody>
        <IndicadoresHeader familia={abaAtiva} />

        <CustomTabs<FamiliaIndicadores>
          tabs={abas}
          activeTab={abaAtiva}
          onChange={onAbaChange}
          className='mb-6 nav-line-tabs-2x'
          // Hierarquia de texto do BRAND.md: gray-700 é apoio (6,0:1), gray-900 é o dado (16,8:1). A escala
          // cinza do Metronic inverte no modo escuro, então a mesma classe serve aos dois. A aba ativa passa a
          // se distinguir por cor E por peso, além do sublinhado — que sozinho media 1,16:1 no escuro.
          tabClassName='fs-5 fw-semibold text-gray-700'
          activeTabClassName='text-gray-900 fw-bolder'
        />

        {abaAtiva === 'operacional' ? (
          <QueryResponseProvider>
            <SecaoOperacional />
          </QueryResponseProvider>
        ) : abaAtiva === 'qualidade' ? (
          <QueryResponseQualidadeProvider>
            <SecaoQualidade />
          </QueryResponseQualidadeProvider>
        ) : (
          <QueryResponsePerformanceProvider>
            <SecaoPerformance />
          </QueryResponsePerformanceProvider>
        )}
      </KTCardBody>
    </KTCard>
  )
}

/**
 * O filtro é um só, no `QueryRequestProvider`, acima das abas: trocar de aba
 * remonta apenas o response provider da família, então o filtro é preservado.
 */
export const IndicadoresPainelWrapper = () => {
  const [abaAtiva, setAbaAtiva] = useState<FamiliaIndicadores>('operacional')

  return (
    <QueryRequestProvider>
      <IndicadoresMoldura abaAtiva={abaAtiva} onAbaChange={setAbaAtiva} />
    </QueryRequestProvider>
  )
}
